import { Link } from "@tanstack/react-router";
import { Camera, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMediaQuery, usePhoneFlag } from "@/hooks/use-capture";

const DISMISSED_KEY = "mesh-take-photos-card-dismissed";

/** On a phone, points a PM from the portal to the capture screens until they dismiss it. */
export function TakePhotosCard() {
  const phone = useMediaQuery("(max-width: 640px)");
  const [dismissed, setDismissed] = usePhoneFlag(DISMISSED_KEY);
  if (!phone || dismissed) return null;

  return (
    <div
      data-testid="take-photos-card"
      className="mb-4 flex items-center gap-3 rounded-lg border bg-[var(--brand-surface)] p-3 dark:bg-[var(--brand-accent)]/15"
    >
      <span className="flex size-10 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary dark:bg-white/10 dark:text-white">
        <Camera className="size-5" />
      </span>
      <p className="min-w-0 flex-1 text-sm">
        Taking photos on site?{" "}
        <Link
          to="/capture"
          className="font-medium text-[var(--brand-accent)] underline-offset-4 hover:underline dark:text-blue-300"
        >
          Open Take photos.
        </Link>
      </p>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label="Dismiss"
        className="shrink-0"
        onClick={() => setDismissed(true)}
      >
        <X />
      </Button>
    </div>
  );
}
